import { RootState } from '../store';

export const selectSmileScanCaseId = (state: RootState): any => state.smileScanCase;
